import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RequestResponsePattern, RequestStatusPattern } from "../../../../../types/Request"


interface State {
    requestGet: RequestStatusPattern<RequestResponsePattern<any[]>>
    requestSave: RequestStatusPattern<RequestResponsePattern<any>>
    requestEdit: RequestStatusPattern<RequestResponsePattern<any>>
    requestRemove: RequestStatusPattern<RequestResponsePattern<any>>
    requestFilter: RequestStatusPattern<RequestResponsePattern<any[]>>

    listaLogs: any[] | null;
    listaSinonimo: any[] | null;
    filteredListaLogs: any[] | null;
    fieldFiltered: string;
    fieldFilteredTabela: string;
    fieldFilteredFlagAtivo: any;
    currentData: any | null;
    fieldDtInicio: string;
    fieldDtFim: string;
}

const initialState: State = {
    requestGet: {
        data: null,
        loading: false,
        error: false,
        message: null,
    },
    requestSave: {
        data: null,
        loading: false,
        error: false,
        message: null,
    },
    requestEdit: {
        data: null,
        loading: false,
        error: false,
        message: null,
    },
    requestRemove: {
        data: null,
        loading: false,
        error: false,
        message: null,
    },
    requestFilter: {
        data: null,
        loading: false,
        error: false,
        message: null,
    },
    listaLogs: null,
    listaSinonimo: null,
    filteredListaLogs: null,
    fieldFiltered: '',
    fieldFilteredTabela: 'null',
    fieldFilteredFlagAtivo: 'null',
    currentData: null,
    fieldDtInicio: '',
    fieldDtFim: '',
}

const DefaultSlice = createSlice({
    name: 'Parametro',
    initialState,
    reducers: {
        setRequestGetData: (state, action: PayloadAction<RequestResponsePattern<any[]>>) => {
            state.requestGet.data = action.payload
            state.requestGet.loading = false
            state.requestGet.error = false
        },
        setRequestGetLoading: (state) => {
            state.requestGet.loading = true
            state.requestGet.error = false
        },
        setRequestGetError: (state) => {
            state.requestGet.loading = false
            state.requestGet.error = true
        },
        setRequestGetMessage: (state, action: PayloadAction<string>) => {
            state.requestGet.message = action.payload
        },

        setRequestSaveData: (state, action: PayloadAction<RequestResponsePattern<any>>) => {
            state.requestSave.data = action.payload
            state.requestSave.loading = false
            state.requestSave.error = false
        },
        setRequestSaveLoading: (state) => {
            state.requestSave.loading = true
            state.requestSave.error = false
        },
        setRequestSaveError: (state) => {
            state.requestSave.loading = false
            state.requestSave.error = true
        },
        setRequestSaveMessage: (state, action: PayloadAction<string>) => {
            state.requestSave.message = action.payload
        },

        setRequestEditData: (state, action: PayloadAction<RequestResponsePattern<any>>) => {
            state.requestEdit.data = action.payload
            state.requestEdit.loading = false
            state.requestEdit.error = false
        },
        setRequestEditLoading: (state) => {
            state.requestEdit.loading = true
            state.requestEdit.error = false
        },
        setRequestEditError: (state) => {
            state.requestEdit.loading = false
            state.requestEdit.error = true
        },
        setRequestEditMessage: (state, action: PayloadAction<string>) => {
            state.requestEdit.message = action.payload
        },

        setRequestRemoveData: (state, action: PayloadAction<RequestResponsePattern<any>>) => {
            state.requestRemove.data = action.payload
            state.requestRemove.loading = false
            state.requestRemove.error = false
        },
        setRequestRemoveLoading: (state) => {
            state.requestRemove.loading = true
            state.requestRemove.error = false
        },
        setRequestRemoveError: (state) => {
            state.requestRemove.loading = false
            state.requestRemove.error = true
        },
        setRequestRemoveMessage: (state, action: PayloadAction<string>) => {
            state.requestRemove.message = action.payload
        },
        setRequestFilterData: (state, action: PayloadAction<RequestResponsePattern<any[]>>) => {
            state.requestFilter.data = action.payload
            state.requestFilter.loading = false
            state.requestFilter.error = false
        },
        setRequestFilterLoading: (state) => {
            state.requestFilter.loading = true
            state.requestFilter.error = false
        },
        setRequestFilterError: (state) => {
            state.requestFilter.loading = false
            state.requestFilter.error = true
        },
        setRequestFilterMessage: (state, action: PayloadAction<string>) => {
            state.requestFilter.message = action.payload
        },

        setLista: (state, action: PayloadAction<any[]>) => {
            state.listaLogs = action.payload
        },
        setListaSinonimo: (state, action: PayloadAction<any[]>) => {
            state.listaSinonimo = action.payload
        },
        setListaFiltered: (state, action: PayloadAction<any[]>) => {
            state.filteredListaLogs = action.payload
        },
        setFieldFiltered: (state, action: PayloadAction<string>) => {
            state.fieldFiltered = action.payload
        },
        setFieldFilteredTabela: (state, action: PayloadAction<string>) => {
            state.fieldFilteredTabela = action.payload
        },
        setFieldFilteredFlagAtivo: (state, action: PayloadAction<number>) => {
            state.fieldFilteredFlagAtivo = action.payload
        },
        setCurrentData: (state, action: PayloadAction<any>) => {
            state.currentData = action.payload
        }, setFieldDtInicio: (state, action: PayloadAction<string>) => {
            state.fieldDtInicio = action.payload
        },
        setFieldDtFim: (state, action: PayloadAction<string>) => {
            state.fieldDtFim = action.payload
        },
    }
})

export const {
    setRequestGetData, setRequestGetLoading, setRequestGetError, setRequestGetMessage,
    setRequestSaveData, setRequestSaveLoading, setRequestSaveError, setRequestSaveMessage,
    setRequestEditData, setRequestEditLoading, setRequestEditError, setRequestEditMessage,
    setRequestRemoveData, setRequestRemoveLoading, setRequestRemoveError, setRequestRemoveMessage, setFieldDtFim,
    setRequestFilterData, setRequestFilterLoading, setRequestFilterError, setRequestFilterMessage, setFieldDtInicio,
    setLista, setFieldFiltered, setListaFiltered, setCurrentData, setFieldFilteredFlagAtivo, setListaSinonimo,
    setFieldFilteredTabela
} = DefaultSlice.actions

export default DefaultSlice.reducer